import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import BootstrapModal from "designs/v1/pages/ModifyKyc/components/BootstrapModal";
import { getApiUrl } from "utils";
import {
  getIncomeReviewApi,
  submitIncomeReviewApi,
  incomeProofForEsign,
} from "designs/v1/pages/ModifyKyc/services";

const IncomeModificationReview = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const history = useHistory();
  const [reviewData, setReviewData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("IncomeRequestNumber"),
    };
    const loadReview = async () => {
      try {
        const resp = await getIncomeReviewApi(payload);
        setReviewData(resp.data?.data);
        console.log("resp", resp);
      } catch (error) {
        console.log("err", error);
      }
    };
    loadReview();
    return () => {
      // localStorage.removeItem("IncomeRequestNumber");
    };
  }, []);

  const handleShowHideModal = () => {
    setShowModal((bool) => !bool);
  };
  const handleSubmit = async () => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("IncomeRequestNumber"),
    };
    console.log("payload", payload);
    setShowModal(false);
    setIsLoading(true);
    try {
      const resp = await submitIncomeReviewApi(payload);
      console.log("resp", resp);
      try {
        const esignResp = await incomeProofForEsign(payload);
        setIsLoading(false);
        if (esignResp.data.message?.status_code !== 200) {
          return toast.error(
            resp.esignResp.message?.message ||
              "Internal server error!"
          );
        }
        if (resp.data.message?.status_code !== 200) {
          return toast.error(
            resp.data.message?.message ||
              "Internal server error!"
          );
        }
        toast.success(resp.data.message?.message);
        setStep("IncomeModificationESignature");
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
      const { data } = error.response;
      toast.error(
        data.message?.message || "Internal server error!"
      );
    }
  };

  return (
    <>
      <Title title="Review Details" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              {reviewData && (
                <div>
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Type</h6>
                      <div className="col-sm">{reviewData?.request_type}</div>
                    </div>
                  </div>
                  <div className="row my-4">
                    <h6 className="text-bold m-0">User Details</h6>
                    <div className="row mt-1">
                      <div className="col-sm">Full Name</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.full_name}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Mobile Number</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.mobile?.slice(2)}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Email Address</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.email}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">PAN Number</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.pan_number}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Reason Details</h6>
                      <div className="col-sm">
                        {reviewData.reason_details?.user_input_reason}
                      </div>
                    </div>
                  </div> */}
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Number</h6>
                      <div className="col-sm">
                        {reviewData.rekyc_nominee_modi_request_name}
                      </div>
                    </div>
                  </div>
                  {reviewData.modification_details?.length && (
                    <>
                      <div className="row my-4">
                        <h6 className="text-bold m-0">New Income Details</h6>
                        <div className="row my-1">
                          <div className="col-sm">Proof Type</div>
                          <div className="col-sm">
                            {reviewData.modification_details[0]?.icp_type}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-sm">Proof File</div>
                          {reviewData.modification_details[0]?.icp && (
                            <a
                              className="col-sm"
                              target="_blank"
                              rel="noopener noreferrer"
                              href={
                                getApiUrl() +
                                reviewData.modification_details[0].icp
                              }
                            >
                              Download here
                            </a>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="row my-4">
                    <Button
                      title="Submit"
                      type="button"
                      handleClick={handleShowHideModal}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BootstrapModal
        show={showModal}
        title="Modify Income Proof"
        content={"Are you sure you want to modify this Income Proof?"}
        loading={isLoading}
        handleClose={handleShowHideModal}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default IncomeModificationReview;
